import BankingOperation from '../../Operation'
import PixForm from '../../Forms/PixForm'

export default function BankingPixKey ({ requestConfig, onCompleted, ...props }) {
  return (
    <BankingOperation title='Área Pix' {...props}>
      {({ availableBalance, pixFee }) => (
        <PixForm
          availableBalance={availableBalance}
          pixFee={pixFee}
          requestConfig={requestConfig}
          onCompleted={onCompleted}
        />
      )}
    </BankingOperation>
  )
}
